import { PlaylistAdd } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { useValidatedType } from '/@/hooks/session';
import { _ } from '/@/locale';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import { FIELDS_EMPTY_STATE } from '../../../growers/components/growers-list';

const CreateRecommendationSection = ({
    setOpenCreateRecommendationModal,
}: {
    setOpenCreateRecommendationModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const userType = useValidatedType();

    const handleClickNewReco = () => {
        mpTrackEvent('RV recommendations pop up opened', { entry_source: 'activity-section' });
        setOpenCreateRecommendationModal(true);
    };

    const titles = FIELDS_EMPTY_STATE[userType as keyof typeof FIELDS_EMPTY_STATE] || FIELDS_EMPTY_STATE.default;

    return (
        <Stack alignItems='center' justifyContent='center' px={2} py={4} backgroundColor='#F5F5F5' height='100%'>
            <PlaylistAdd sx={{ width: 36, height: 36, mb: 1 }} color='primary' />
            <Stack mb={3} textAlign='center'>
                <Typography variant='subtitle1' fontWeight='bold' color='primary'>
                    {titles.recommendations.title}
                </Typography>
                <Typography variant='subtitle1' color='primary.mui.inactive'>
                    {titles.recommendations.subtitle}
                </Typography>
            </Stack>
            <Button variant='contained' color='secondary' onClick={handleClickNewReco}>
                {_('Generar Recomendación')}
            </Button>
        </Stack>
    );
};

export default CreateRecommendationSection;
